import { MutationTree } from 'vuex'

import { ContributerState } from '@/types/store'
import { IReceipt } from '@/types/receipt'

export const mutations: MutationTree<ContributerState> = {
  contributersLoadStart(state) {
    state.isContributersLoading = true
  },
  contributersLoaded(state, payload: [IReceipt[], number]) {
    state.contributers = payload[0]
    state.total = payload[1]
    state.isContributersLoading = false
  },
}
